import axios from "axios";

export async function getBanks(wiseEmail, token) {
  const response = await axios.get(
    `/api/wise/user/banks/${wiseEmail && wiseEmail}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );
  return response.data;
}

export async function getBankFromCompany(wiseProfileId, userEmail, token) {
  const banks = await getBanks(userEmail, token);
  if (!banks) return [];
  if (!wiseProfileId) return banks;
  return banks.filter((bank) => bank.profile === parseInt(wiseProfileId));
}

export async function getBanksByWiseSettingsId(wiseSettingsId, wiseEmail, token) {
  const response = await axios.get(
    `/api/wise/user/banks/by/wise/settings/id/${wiseSettingsId && wiseSettingsId}/${wiseEmail && wiseEmail}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );

  return response.data;
}

export async function getBankFromCompanyWiseSettingsId(wiseSettingsId, wiseProfileId, userEmail, token) {
  const banks = await getBanksByWiseSettingsId(wiseSettingsId, userEmail, token);
  if (!banks) return [];
  if (!wiseProfileId) return banks;
  return banks.filter((bank) => bank.profile === parseInt(wiseProfileId));
}

export async function getUserInvoice(id, token) {

  const response = await axios.get(`/api/invoice/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;

}

export async function bankDetail(invoiceData, token) {
  try {
    const response = await axios.post(`/api/wise/bank/details`, {
      invoiceId: invoiceData && invoiceData._id
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = Array.isArray(response.data) ? response.data[0] : response.data;
    return result;
  } catch (e) {
    console.log(e);
  }
}

export async function venBankDetail(invoiceData, token) {
  try {
    const response = await axios.post(`/api/wise/vendor/bank/details`, {
      invoiceId: invoiceData && invoiceData._id
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const result = Array.isArray(response.data) ? response.data[0] : response.data;
    return result;
  } catch (e) {
    console.log(e);
  }
}